import type { CustomColumnConfig } from '@/hooks/useColumnConfig';

import {
  columnSourceKey,
  configuredColumn,
  type ColumnFieldOption as FieldOption,
} from './schema-extensions/extensionColumns';
export type { ColumnFieldOption as FieldOption } from './schema-extensions/extensionColumns';

/**
 * The column the Add Column form makes from a field and a header: numeric
 * fields right-aligned. `null` until both are filled in.
 */
export function newColumnFromField(
  fields: readonly FieldOption[],
  fieldKey: string,
  header: string,
): Omit<CustomColumnConfig, 'id'> | null {
  const title = header.trim();
  if (!fieldKey || !title) return null;
  const field = fields.find((f) => columnSourceKey(f) === fieldKey);
  if (field) return configuredColumn(field, title);
  const format = undefined;
  return {
    header: title,
    apiField: fieldKey,
    alignRight: false,
    format,
  };
}
